<template>
    <div class="bg-gray-200 h-screen">
        <div class="container mx-auto pt-20">
            <h1 class="text-5xl font-bold text-center text-gray-700 mb-8">
                Welcome to My Awesome App
            </h1>
            <p class="text-center text-gray-700 text-xl mb-12">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed faucibus
                quam sed erat laoreet, ac varius nulla convallis. Integer id eros ac
                enim tincidunt pellentesque.
            </p>
            <div class="flex justify-center">
                <a
                    href="#"
                    class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-full"
                >
                    Sign Up
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LandingPage",
};
</script>
